module.exports = "<i :class=\"[nameClass, typeClass]\"></i>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/icon/icon.vue
 ** module id = 119
 ** module chunks = 0
 **/